/* eslint-disable no-unused-vars */

import Vue from 'vue'

export const LaneClosureListModule = {
	strict: true, // for developement only
	namespaced: true,
	state: {
		grid: [{
				title: 'Requests',
				name: 'requests',
				statusLookup: 'getApprovalStatusIdOptions',
				showFilter: true,
				columns: [{
						key: 'affectedStreet',
						label: 'LOCATION',
						alternateLabel: 'AFFECTED STREET',
						filter: {
							show: true,
							key: 'affectedStreet',
							autoComplete: {
								search: 'laneClosureList/searchStreetByName',
								label: 'streetName',
								name: 'streetName'
							}
						},
						sortable: true,
						widths: "xs24 l5"
                    },
					{
						key: 'date',
						label: "DATE(s)",
						filter: {
							show: true,
							key: 'fromDateTime',
							datePicker: {
								from: 'fromDateTime',
								to: 'toDateTime'
							}
						},
						sortable: true,
						widths: "xs24 l5",
						separator: true
                    },
					{
						key: "map",
						label: "MAP",
						widths: "xs8 l2"
                    },
					{
						key: "status",
						label: "STATUS",
						widths: "xs12 l3",
                    },
					{
						key: "requesterProjectName",
						label: 'PROJECT',
						filter: {
							show: true,
							key: 'requesterProjectId',
							autoComplete: {
								search: 'laneClosureList/searchProjectByName',
								label: 'name',
								name: 'id',
								organizationName: 'organizationName'
							}
						},
						sortable: false,
						widths: "xs24 l3",
                    },
					{
						key: "owner",
						label: "OWNER",
						alternateLabel: "CONTACT",
						filter: {
							show: false,
							key: 'organizationId'
						},
						sortable: false,
						widths: "xs16 l4"
                    },
					{
						key: "idAndRef",
						label: 'ID & TM',
						alternateLabel: 'ID',
						filter: {
							show: false,
							key: 'idAndRef',
						},
						sortable: true,
						widths: "xs12 l2"
			},
                ]
            },
			{
				title: 'Closures',
				name: 'closures',
				statusLookup: 'getActiveStatusIdOptions',
				showFilter: true,
				columns: [{
						key: 'affectedStreet',
						label: 'LOCATION',
						alternateLabel: 'AFFECTED STREET',
						filter: {
							show: true,
							key: 'affectedStreet',
							autoComplete: {
								search: 'laneClosureList/searchStreetByName',
								label: 'streetName',
								name: 'streetName'
							}
						},
						sortable: true,
						widths: "xs24 l5"
                    },
					{
						key: 'date',
						label: "DATE(s)",
						filter: {
							show: true,
							key: 'fromDateTime',
							datePicker: {
								from: 'fromDateTime',
								to: 'toDateTime'
							}
						},
						sortable: true,
						widths: "xs24 l5",
						separator: true
                    },
					{
						key: "map",
						label: "MAP",
						widths: "xs8 l2"
                    },
					{
						key: "status",
						label: "STATUS",
						widths: "xs12 l3",
                    },
					{
						key: "requesterProjectName",
						label: 'PROJECT',
						filter: {
							show: true,
							key: 'requesterProjectId',
							autoComplete: {
								search: 'laneClosureList/searchProjectByName',
								label: 'name',
								name: 'id'
							}
						},
						sortable: false,
						widths: "xs24 l3",
                    },
					{
						key: "owner",
						label: "OWNER",
						alternateLabel: "CONTACT",
						filter: {
							show: false,
							key: 'organizationId'
						},
						sortable: false,
						widths: "xs16 l4"
                    },
					{
						key: "id",
						label: 'ID & TYPE',
						alternateLabel: 'LCR',
						filter: {
							show: false,
							key: 'id',
						},
						sortable: false,
						widths: "xs12 l2"
                    },
                ]
            },
			{
				title: 'Restrictions',
				name: 'restrictions',
				showFilter: true,
				statusLookup: 'getActiveStatusIdOptions',
				columns: [{
						key: 'affectedStreet',
						label: 'LOCATION',
						alternateLabel: 'AFFECTED STREET',
						filter: {
							show: true,
							key: 'affectedStreet',
							autoComplete: {
								search: 'laneClosureList/searchStreetByName',
								label: 'streetName',
								name: 'streetName'
							}
						},
						sortable: true,
						widths: "xs24 l5"
                    },
					{
						key: 'date',
						label: "DATE(s)",
						filter: {
							show: true,
							key: 'fromDateTime',
							datePicker: {
								from: 'fromDateTime',
								to: 'toDateTime'
							}
						},
						sortable: true,
						widths: "xs24 l5",
						separator: true
                    },
					{
						key: "map",
						label: "MAP",
						widths: "xs8 l2"
                    },
					{
						key: "status",
						label: "STATUS",
						widths: "xs12 l3",
                    },
					{
						key: "requesterProjectName",
						label: 'PROJECT',
						filter: {
							show: true,
							key: 'requesterProjectId',
							autoComplete: {
								search: 'laneClosureList/searchProjectByName',
								label: 'name',
								name: 'id'
							}
						},
						sortable: false,
						widths: "xs24 l3",
                    },
					{
						key: "owner",
						label: "OWNER",
						alternateLabel: "CONTACT",
						filter: {
							show: false,
							key: 'organizationId'
						},
						sortable: false,
						widths: "xs16 l4"
                    },
					{
						key: "id",
						label: 'ID & TYPE',
						alternateLabel: 'LCR',
						filter: {
							show: false,
							key: 'id',
						},
						sortable: false,
						widths: "xs12 l2"
                    },
                ]
            },
			{
				title: 'Violations',
				name: 'contraventions',
				statusLookup: null,
				showFilter: false,
				columns: [{
						key: 'affectedStreet',
						label: 'LOCATION',
						alternateLabel: 'AFFECTED STREET',
						filter: {
							show: true,
							key: 'affectedStreet',
							autoComplete: {
								search: 'laneClosureList/searchStreetByName',
								label: 'streetName',
								name: 'streetName'
							}
						},
						sortable: true,
						widths: "xs24 l5"
                    },
					{
						key: 'date',
						label: "DATE(s)",
						filter: {
							show: true,
							key: 'fromDateTime',
							datePicker: {
								from: 'fromDateTime',
								to: 'toDateTime'
							}
						},
						sortable: true,
						widths: "xs24 l5",
						separator: true
                    },
					{
						key: "map",
						label: "MAP",
						widths: "xs8 l2"
                    },
					{
						key: "status",
						label: "STATUS",
						widths: "xs12 l3",
                    },
					{
						key: "requesterProjectName",
						label: 'PROJECT',
						filter: {
							show: true,
							key: 'requesterProjectId',
							autoComplete: {
								search: 'laneClosureList/searchProjectByName',
								label: 'name',
								name: 'id'
							}
						},
						sortable: false,
						widths: "xs24 l3",
                    },
					{
						key: "owner",
						label: "OWNER",
						alternateLabel: "CONTACT",
						filter: {
							show: false,
							key: 'organizationId'
						},
						sortable: false,
						widths: "xs16 l4"
                    },
					{
						key: "id",
						label: 'ID & TYPE',
						alternateLabel: 'LCR',
						filter: {
							show: false,
							key: 'id',
						},
						sortable: false,
						widths: "xs12 l2"
                    },
                ]
            },
        ],
		data: Array(),
		params: {
			sortOrder: null,
			sortBy: null,
			keywords: null,
			page: 0
		},
		activeIndex: 0,
		lastUpdatedTime: null,
	},
	mutations: {
		setData: (state, payload = Array()) => {
			state.data = payload;
			if (state.data.conflicts != null) {
				for (var z = 0; z < state.data.conflicts.length; z++) {
					for (var x = 0; x < state.data.data.length; x++) {
						if (state.data.conflicts[z].lcrId == state.data.data[x].id) {
							state.data.data[x].conflicts.push(state.data.conflicts[z]);
						}
					}
					for (var y = 0; y < state.data.mapData.length; y++) {
						if (state.data.conflicts[z].lcrId == state.data.mapData[y].id) {
							state.data.mapData[y].conflicts.push(state.data.conflicts[z]);
						}
					}
				}
			}
		},

		setParams: (state, params) => {
			state.params = {
				...state.params,
				...params
			}
		},
		resetParams: state => {
			let arg = "globalFilter";
			let argQuery = JSON.parse(localStorage.getItem(arg))
			if (argQuery != null) {
				state.params = argQuery;
			} else {
				state.params = {}
			}
		},
		setActiveIndex: (state, params) => {
			state.activeIndex = params;
		},
		setActiveTabName: (state, params) => {
			state.activeTabName = params;
		},
		setPagination: (state, attr) => {
			state.data = {
				...state.data,
				...attr
			}
		},
		removeElement: (state, attribute) => {
			let paramState = {...state.params
			}
			delete paramState[attribute]
			state.params = {...paramState
			}
		},
		setTotal: (state, data) => {
			state.data = {
				...state.data,
				total: data
			}
		},
		updateLastUpdatedTime: (state) => {
			state.lastUpdatedTime = new Date()
		}
	},
	getters: {
		getAllData: state => state.data,
		getRecords: state => state.data.data,
		getConflicts: state => state.data.conflicts,
		getNearbyRecords: state => state.data.mapData,
		getAffectedLocation: state => {
			let lists = Array()
			state.data.data.forEach(item => {
				if (item.affectedStreet) {
					lists.push({
						location: item.affectedStreet
					})
				}
				if (item.firstCrossStreet) {
					lists.push({
						location: item.firstCrossStreet
					})
				}
				if (item.lastCrossStreet) {
					lists.push({
						location: item.lastCrossStreet
					})
				}
			})
			const res = new Set()
			return (
				lists.filter(elem => {
					const duplicate = res.has(elem.location);
					res.add(elem.location);
					return !duplicate;
				})
			)
		},
		getGrid: state => state.grid,
		getTotals: state => state.data.total,
		getPagination: state => {
			return {
				count: state.data.count,
				page: state.data.page,
				perPage: state.data.perPage
			}
		},
		getParams: state => {
			return state.params
		},
		getActiveIndex: state => {
			return state.activeIndex
		},
		getActiveTabName: state => {
			return state.activeTabName
		},
		getLastUpdatedDate: state => {
			return state.lastUpdatedTime
		}
	},
	actions: {
		async load({
			commit,
			rootState
		}, params = Object()) {
			var x = 0;
			var newParam = [];

			if (params) {
				if (params.fromDateTime) {
					if (params.fromDateTime == "Invalid date") {
						params.fromDateTime = null;
					}
				}
				if (params.toDateTime) {
					if (params.toDateTime == "Invalid date") {
						params.toDateTime = null;
					}
				}
			}
			if (params.affectedStreet) {
				if (params.affectedStreet.id !== undefined) {
					newParam = [];
					if (params.affectedStreet.id != null) {
						newParam.push(params.affectedStreet.id);
					}
					params.affectedStreet = [];
					for (x = 0; x < newParam.length; x++) {
						params.affectedStreet.push(newParam[x]);
					}
				} else {
					if (params.affectedStreet.length > 0) {
						newParam = [];
						for (x = 0; x < params.affectedStreet.length; x++) {
							if (params.affectedStreet[x].id !== undefined) {
								if (params.affectedStreet[x].id != null) {
									newParam.push(params.affectedStreet[x].id);
								}
							} else {
								newParam.push(params.affectedStreet[x]);
							}
						}
						params.affectedStreet = [];
						for (x = 0; x < newParam.length; x++) {
							params.affectedStreet.push(newParam[x]);
						}
					} else {
						params.affectedStreet = null;
					}
				}
			} else {
				params.affectedStreet = null;
			}

			if (params.requesterProjectId) {
				if (params.requesterProjectId.id !== undefined) {
					newParam = [];
					if (params.requesterProjectId.id != null) {
						newParam.push(parseInt(params.requesterProjectId.id));
					}
					params.requesterProjectId = [];
					for (x = 0; x < newParam.length; x++) {
						params.requesterProjectId.push(newParam[x]);
					}
				} else {
					if (params.requesterProjectId.length > 0) {
						newParam = [];
						for (x = 0; x < params.requesterProjectId.length; x++) {
							if (params.requesterProjectId[x].id != undefined) {
								if (params.requesterProjectId[x].id != null) {
									newParam.push(parseInt(params.requesterProjectId[x].id));
								}
							} else {
								newParam.push(params.requesterProjectId[x]);
							}
						}
						params.requesterProjectId = [];
						for (x = 0; x < newParam.length; x++) {
							params.requesterProjectId.push(parseInt(newParam[x]));
						}
					} else {
						params.requesterProjectId = null;
					}
				}
			} else {
				params.requesterProjectId = null;
			}

			try {
				let res = await Vue.prototype.$http.post(rootState.apiUrl + '/lane-closure-request/list/', params);
			commit('setData', res.data)
			commit('updateLastUpdatedTime')
			} catch(error) {
				var emptyData = {
					data:[],
					conflicts:[],
					page:1,count:0,perPage:20,
					total:{
						requests:{pending:0,approved:0,denied:0},
						closures:{planned:0,active:0,expired:0},
						restrictions:{planned:0,active:0,expired:0},
						contraventions:{expired:0,with:0,without:0}
					}
				};
				Vue.prototype.$bus.$emit("error:network", {error:error,submitted:null});
				commit('setData', emptyData)
				commit('updateLastUpdatedTime')
			}

		},
		async searchStreetByName({
			commit,
			rootState
		}, input) {
			if (!input) {
				input = "-0-"
			}
			try {
			const res = await Vue.prototype.$http.get(rootState.apiUrl + '/block/affected-street?q=' + encodeURI(input))
			return res.data
			} catch(error) {
				return {};
			}
		},
		async searchActiveStreetByName({
			commit,
			rootState
		}, input) {
			if (!input) {
				input = "-0-"
			}
			try {
				const res = await Vue.prototype.$http.get(rootState.apiUrl + '/block/active-affected-street?q=' + encodeURI(input))
				return res.data
			} catch(error) {
				return {};
			}
		},
		async searchProjectByName({
			commit,
			rootState
		}, input) {
			try {
			let res = await Vue.prototype.$http.get(rootState.apiUrl + '/project/filterable?q=' + encodeURI(input))
			return res.data
			} catch(error) {
				return {};
			}
		},
		async searchUserByName({
			commit,
			rootState
		}, input) {
			try {
			let res = await Vue.prototype.$http.get(rootState.apiUrl + '/organization/users/assignable?q=' + encodeURI(input))
			return res.data
			} catch(error) {
				return {};
			}
		},
		clearParams({
			commit
		}) {
			commit('resetParams')
		},
		updateParams({
			commit
		}, params = Object()) {
			commit('setParams', params)
		},
		updateActiveIndex({
			commit
		}, index) {
			commit('setActiveIndex', index)
		},
		updateActiveTabName({
			commit
		}, name) {
			commit('setActiveTabName', name)
		},
		clearStatusFilters({
			commit
		}) {
			let params = {
				approvalStatusId: null,
				activeStatusId: null
			}
			commit('setParams', params)
		},
		removePropInParam({
			commit
		}, attr = '') {
			commit('removeElement', attr)
		},
		updatePagination({
			commit
		}, attr) {
			commit('setPagination', attr)
		},

		loadPdf({
			commit,
			rootState
		}, params = Object()) {
			try {
			return Vue.prototype.$http.post(rootState.apiUrl + '/lane-closure-request/list/print', params, {
				responseType: 'blob'
			})
			} catch(error) {
				Vue.prototype.$bus.$emit("error:network", {error:error,submitted:null});
			}
		},
		async loadTotal({
			commit,
			rootState,
			getters
		}, params = Object()) {
			let lastUpdatedTime = getters['getLastUpdatedDate']
			if (!lastUpdatedTime || (new Date() - lastUpdatedTime > rootState.updateTotalInterval)) {
				try {
						let res = await Vue.prototype.$http.post(rootState.apiUrl + '/lane-closure-request/list/total', params);
						commit('setTotal', res.data.total);
						commit('updateLastUpdatedTime');
				} catch (error) {
					Vue.prototype.$bus.$emit("error:network", {error:error,submitted:null});
					var emptyData = {
						total:{
							requests:{pending:0,approved:0,denied:0},
							closures:{planned:0,active:0,expired:0},
							restrictions:{planned:0,active:0,expired:0},
							contraventions:{expired:0,with:0,without:0}
						}
					};
					commit('setTotal', emptyData.total);
					commit('updateLastUpdatedTime');
				}
			}
		}
	}
}